import ClickToPausePlugin from './click_to_pause'
export default ClickToPausePlugin



// WEBPACK FOOTER //
// ./src/plugins/click_to_pause/index.js